import React, { useEffect } from 'react'
import { useDispatch, useSelector } from 'react-redux'
import { Translate } from 'react-redux-i18n'
import { useLocation } from 'react-router'
import { Icon } from '../../../../../../../common/html/icon'
import { Loading } from '../../../../../../../common/loading'
import { Panel } from '../../../../../../../common/panel'
import { Tooltip } from '../../../../../../../common/tooltip'
import { selectLoading } from '../../../../store/slice'
import { getPDTermStructureThunk } from '../../../../store/thunk'
import ForwardLookingPDTermStructureContent from './ForwardLookingPDTermStructureContent'

const ForwardLookingPDTermStructure = () => {
  const dispatch = useDispatch()
  const location = useLocation()

  const locale = useSelector((state) => state.i18n.locale)
  const isLoading = useSelector(selectLoading('listPDTermStructure'))
  const params = new Proxy(new URLSearchParams(location.search), {
    get: (searchParam, prop) => searchParam.get(prop),
  })
  useEffect(() => {
    dispatch(
      getPDTermStructureThunk({
        OrganizationId: params.organizationId,
      }),
    )
  }, [locale])

  return (
    <Panel
      isI18n
      label="forwardLookingPDTermStructure.title"
      renderLabel={() => {
        return (
          <div>
            <Tooltip
              contentStyle={{
                display: 'flex',
                alignItems: 'center',
                paddingLeft: 4,
              }}
              tooltipStyle={{
                maxWidth: 400,
              }}
              tooltipContent={
                <div className="textCenter" style={{ textAlign: 'justify' }}>
                  <Translate value="forwardLookingPDTermStructure.tooltip" />
                </div>
              }
            >
              <Icon
                className="icon-info-circle"
                style={{ fontSize: 16, color: '#9C9C9C' }}
              />
            </Tooltip>
          </div>
        )
      }}
    >
      <div style={{ padding: 12, position: 'relative', minHeight: 200 }}>
        {isLoading ? <Loading /> : <ForwardLookingPDTermStructureContent />}
      </div>
    </Panel>
  )
}

export default ForwardLookingPDTermStructure
